export enum CodeListStatus{
  Assigned='Assigned',
  Available='Available'
}